var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.showPopUp)?_c('Popup',{attrs:{"imagePath":_vm.popUpImage},on:{"close":_vm.onPopUpClose}}):_vm._e(),_c('Sidebar',{on:{"openPopUp":_vm.onPopUpOpen}}),_c('Viewport')],1)}
var staticRenderFns = []

export { render, staticRenderFns }